import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { idToLink } from 'inside-out/managers/navManager';
import { PageHeader } from 'inside-out/components/shared/pageHeader';
import { Cards } from 'inside-out/components/shared/cards';
import { MediaCard } from 'inside-out/components/shared/cards/mediaCard';

import {
	innerWrapperStyle,
	sectionsStyle,
	introStyle,
	leftStyle,
	rightStyle,
} from 'inside-out/page-styles/media-office';

import { burnedOrange, contentSection, cardSection } from 'inside-out/global-styles';

import { navigateTo } from 'inside-out/components/shared/link';
import { Pagination } from 'inside-out/components/shared/pagination';

const hasVideoAttachment = node =>
	node.attachments && node.attachments.find(attachment => attachment.vimeo_url);

export default class MediaOfficePage extends React.PureComponent {
	static propTypes = {
		pathContext: PropTypes.shape({
			pageNumber: PropTypes.number.isRequired,
			totalPages: PropTypes.number.isRequired,
		}).isRequired,
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							main_heading: PropTypes.string.isRequired,
							main_body: PropTypes.string.isRequired,
							heading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							phone_numbers: PropTypes.arrayOf(
								PropTypes.shape({
									number: PropTypes.string.isRequired,
								})
							),
							email: PropTypes.string.isRequired,
						}),
					})
				),
			}),
			media: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							title: PropTypes.string,
							type: PropTypes.string,
							attachments: PropTypes.arrayOf(
								PropTypes.shape({
									file: PropTypes.string,
								})
							),
							date: PropTypes.string,
							thumbnail: PropTypes.string,
						}).isRequired,
					}).isRequired
				),
			}).isRequired,
		}).isRequired,
	};

	render() {
		const { pageNumber, totalPages } = this.props.pathContext;
		const { page, media } = this.props.data;
		const pageSettings = page.edges[0].node;

		return (
			<React.Fragment>
				<Helmet title={pageSettings.main_heading}>
					<meta property="og:type" content="website"/>
			    <meta property="og:title" content={pageSettings.main_heading}/>
				</Helmet>

				<PageHeader
					background={burnedOrange}
					titleText={pageSettings.main_heading}
					titleTextColor="#fff"
					subTitleText={pageSettings.main_body}
					subTitleTextColor="#fff"
				/>
				<section className={introStyle}>
					<div className={leftStyle}>
						<h1>{pageSettings.heading}</h1>
						<p>{pageSettings.body}</p>
					</div>
					<div className={rightStyle}>
						<div>
							<h2>Phone numbers</h2>
							{pageSettings.phone_numbers.map(({ number }) => <span key={number}>{number}</span>)}
						</div>
						<div>
							<h2>email address</h2>
							<span>
								<a href={`mailto:${pageSettings.email}`} target="_blank">
									{pageSettings.email}
								</a>
							</span>
						</div>
					</div>
				</section>
				<div className={sectionsStyle}>
					<section className={contentSection('#F6F6F6')}>
						<div className={innerWrapperStyle}>
							<div className={cardSection()}>
								<Cards columns={4}>
									{media.edges.map(({ node }, index) => (
										<MediaCard
											key={index}
											to={idToLink(node.id)}
											hasVideo={hasVideoAttachment(node)}
											background={
												node.fields && node.fields.thumbnail_image.childImageSharp.resize.src
											}
											title={node.title}
											body={node.extract}
											date={node.date}
										/>
									))}
								</Cards>
							</div>
						</div>
					</section>

					{totalPages !== 1 && (
						<Pagination
							initialPage={pageNumber}
							pageCount={totalPages}
							onPageChange={page => {
								navigateTo(page === 1 ? `/media-office` : `/media-office/${page}`);
							}}
						/>
					)}
				</div>
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query MediaOfficePage($skip: Int, $limit: Int) {
		page: allContentJson(filter: { id: { regex: "/content\\/media-office-page\\.json/" } }) {
			edges {
				node {
					main_heading
					main_body
					heading
					body
					phone_numbers {
						number
					}
					email
				}
			}
		}

		media: allMediaOfficeJson(sort: { order: DESC, fields: [date] }, skip: $skip, limit: $limit) {
			edges {
				node {
					id
					title
					extract
					date
					# fields {
					# 	thumbnail_image {
					# 		childImageSharp {
					# 			resize(width: 600, height: 320, cropFocus: CENTER) {
					# 				src
					# 			}
					# 		}
					# 	}
					# }
					# attachments {
					# 	file
					# 	url
					# 	link_text
					# 	vimeo_url
					# }
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/media-office/index.js